import * as React from 'react';
import {ProgramObject, FoodItem} from 'api/program/types';
import {Builder} from 'components/Builder';
import {Settings} from './components/Settings';
import {Content} from './components/Content';
import {FoodBuilderProps} from './types';

/**
 * The component create or update an food program.
 * @param {FoodBuilderProps} props
 * @return {React.ReactElement<FoodBuilderProps>}
 * @constructor
 */
export default function FoodBuilder(
    props: FoodBuilderProps,
): React.ReactElement<FoodBuilderProps> {
  const defaultValue: Partial<ProgramObject<FoodItem>> = {
    days: [],
    shortDescription: '',
  };

  return (
    <Builder<ProgramObject<FoodItem>>
      defaultValue={defaultValue}
      {...props}
    >
      {{
        content: (
          <React.Fragment>
            <Settings />
            <br/>
            <Content />
          </React.Fragment>
        ),
        footer: (options) => (
          <Builder.Footer {...options} />
        ),
      }}
    </Builder>
  );
}
